import React from 'react'

import { CriteriaForm } from './CriteriaForm'

interface IProps {
  PartnerID: string
  flexWidth?: string
  rid: number
  appSource: string
}

const fields = [
  {
    label: 'Transactional Data Pack for all SKUs',
    code: 'PC_SELLTO',
    addition: 'Applies to: NA only',
  },
  {
    label: 'Transactional Data Pack for Supplies SKUs',
    code: 'PC_SBD',
    addition: 'Applies to: All markets',
  },
  {
    label: 'Supplies Share of Business',
    code: 'PC_SOB_SUPP',
    addition: 'Applies to: NA only',
  },
]

export const PowerCriteria = (props: IProps) => {
  return (
    <CriteriaForm
      PartnerID={props.PartnerID}
      fields={fields}
      flexWidth={props.flexWidth}
      rid={props.rid}
      appSource={props.appSource}
    />
  )
}
